import { Center, Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { Outlet, useLocation } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { ActivityType } from "__graphql__/types";
import { useLayoutStore } from "app/stores/useLayoutStore";
import { routes } from "config/routes";
import { useCheckClaimedProductsOnLanding } from "flows/Inbound/stores/useInboundDropService";
import { Page } from "shared/components/Page";
import { useActivityRouteTracker } from "shared/hooks/useActivityRouteTracker";
import { Spinner } from "ui/Spinner/Spinner";
import { TitleM } from "ui/Typography/Typography";

export function CollaborativeInbound() {
  const intl = useIntl();
  const { withTabList } = useLayoutStore(
    useShallow((state) => ({
      withTabList: state.withTabList,
    })),
  );
  const { isFetchingClaimedProducts } = useCheckClaimedProductsOnLanding();

  const location = useLocation();
  const isInTrackedZone = location.pathname !== routes.inbound.root;
  useActivityRouteTracker(ActivityType.inbounding, isInTrackedZone);

  if (!withTabList) return <Outlet />;

  return (
    <Page h="100%" pos="relative" isFull isBgGrey justifyContent="flex-start">
      <Flex bg="white" p="s200" w="100%" alignItems="center">
        <TitleM flex={1} noOfLines={1} textOverflow="ellipsis" marginLeft="s100">
          {intl.formatMessage({
            id: "flows.inbound.inbound-pages.header",
          })}
        </TitleM>
      </Flex>
      <Flex h="100%" direction="column" w="100%" overflowY="scroll">
        {isFetchingClaimedProducts ? (
          <Center h="100%" w="100%">
            <Spinner />
          </Center>
        ) : (
          <Outlet />
        )}
      </Flex>
    </Page>
  );
}
